import { API_ERROR_CODES, API_ERROR_DESCRIPTIONS } from './api';
import { CLIENT_ERROR_CODES, CLIENT_ERROR_DESCRIPTIONS } from './client';
import { GENERAL_ERROR_CODES, GENERAL_ERROR_DESCRIPTIONS } from './general';
export const ERROR_CODES = {
    ...CLIENT_ERROR_CODES,
    ...API_ERROR_CODES,
    ...GENERAL_ERROR_CODES,
};
export const ERROR_DESCRIPTIONS = {
    ...CLIENT_ERROR_DESCRIPTIONS,
    ...API_ERROR_DESCRIPTIONS,
    ...GENERAL_ERROR_DESCRIPTIONS,
};
